import { useEffect, useRef, useState } from "react";

import { useInView } from "react-intersection-observer";

import { useAnalyticsEvents } from "@atlaskit/analytics-next";

import { useAnalyticsClient } from "../../analytics/wac-analytics/analytics-client";

type ScrollTrackingProps = {
    section: string | undefined;
    index: string;
    children: React.ReactNode;
    pageId?: string;
};

type AnalyticsPayload = {
    eventType: string;
    action: string;
    actionSubject: string;
    source: string;
    attributes: {
        section: string | undefined;
        scrollPercentage: number;
        pageChildIndex: string;
        pageId?: string;
    };
};

export const ScrollTracking = ({
    section,
    index,
    children,
    pageId
}: ScrollTrackingProps) => {
    const [hasFunctionBeenCalled, setHasFunctionBeenCalled] = useState(false);
    const scrollPercentage = useRef(0);
    const { ref, inView } = useInView({ threshold: 0.5 });
    const analyticsClient = useAnalyticsClient();
    const { createAnalyticsEvent } = useAnalyticsEvents();

    const handleScroll = () => {
        const windowHeight = window.innerHeight;
        const fullHeight = document.documentElement.scrollHeight;
        const currentPosition = window.scrollY;

        scrollPercentage.current = Math.round(
            (currentPosition / (fullHeight - windowHeight)) * 100
        );
    };

    useEffect(() => {
        if (inView && !hasFunctionBeenCalled && section) {
            handleScroll();

            const scrollTrackAnalyticsPayload: AnalyticsPayload = {
                eventType: "ui",
                action: "scrolledTo",
                actionSubject: "section",
                source: window.location.pathname,
                attributes: {
                    section: section,
                    scrollPercentage: scrollPercentage.current,
                    pageChildIndex: index
                }
            };

            if (pageId) {
                scrollTrackAnalyticsPayload.attributes.pageId = pageId;
            }

            if (analyticsClient) {
                createAnalyticsEvent({
                    ...scrollTrackAnalyticsPayload
                }).fire();
                setHasFunctionBeenCalled(true); // Set the state to true so the function won't be called again
            }
        }
    }, [
        analyticsClient,
        createAnalyticsEvent,
        hasFunctionBeenCalled,
        inView,
        index,
        pageId,
        section
    ]);
    return <div ref={ref}>{children} </div>;
};
